import { render, staticRenderFns } from "./AppComboboxUserInputSearching.vue?vue&type=template&id=63125561&"
import script from "./AppComboboxUserInputSearching.vue?vue&type=script&lang=js&"
export * from "./AppComboboxUserInputSearching.vue?vue&type=script&lang=js&"
import style0 from "./AppComboboxUserInputSearching.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib/components/VCombobox';
installComponents(component, {VCombobox})
